/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionNotificationType } from './SubscriptionNotificationType';
import {
    SubscriptionNotificationTypeFromJSON,
    SubscriptionNotificationTypeFromJSONTyped,
    SubscriptionNotificationTypeToJSON,
    SubscriptionNotificationTypeToJSONTyped,
} from './SubscriptionNotificationType';
import type { SubscriptionResourceType } from './SubscriptionResourceType';
import {
    SubscriptionResourceTypeFromJSON,
    SubscriptionResourceTypeFromJSONTyped,
    SubscriptionResourceTypeToJSON,
    SubscriptionResourceTypeToJSONTyped,
} from './SubscriptionResourceType';
import type { SubscriptionStatus } from './SubscriptionStatus';
import {
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
    SubscriptionStatusToJSONTyped,
} from './SubscriptionStatus';
import type { SubscriptionCdc } from './SubscriptionCdc';
import {
    SubscriptionCdcFromJSON,
    SubscriptionCdcFromJSONTyped,
    SubscriptionCdcToJSON,
    SubscriptionCdcToJSONTyped,
} from './SubscriptionCdc';
import type { QueryExpression } from './QueryExpression';
import {
    QueryExpressionFromJSON,
    QueryExpressionFromJSONTyped,
    QueryExpressionToJSON,
    QueryExpressionToJSONTyped,
} from './QueryExpression';
import type { SubscriptionQuotas } from './SubscriptionQuotas';
import {
    SubscriptionQuotasFromJSON,
    SubscriptionQuotasFromJSONTyped,
    SubscriptionQuotasToJSON,
    SubscriptionQuotasToJSONTyped,
} from './SubscriptionQuotas';

/**
 * Subscription model represents a subscription to produce notifications that can be consumed.
 * @export
 * @interface Subscription
 */
export interface Subscription {
    /**
     * Internal unique identifier of the resource, following UUIDv7 format.
     * @type {string}
     * @memberof Subscription
     */
    id: string;
    /**
     * Display name of the subscription.
     * @type {string}
     * @memberof Subscription
     */
    name: string;
    /**
     * The memberIdentifier used by the notification engine to read data for this subscription. Default: subscription creator's memberIdentifier.
     * @type {string}
     * @memberof Subscription
     */
    memberIdentifier: string;
    /**
     * 
     * @type {SubscriptionNotificationType}
     * @memberof Subscription
     */
    notificationType: SubscriptionNotificationType;
    /**
     * 
     * @type {SubscriptionResourceType}
     * @memberof Subscription
     */
    resourceType: SubscriptionResourceType;
    /**
     * Internal unique identifier of the resource. Id can have different formats like UUID v4, UUID v7, or any other string calculated.
     * @type {string}
     * @memberof Subscription
     */
    resourceId?: string;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof Subscription
     */
    status: SubscriptionStatus;
    /**
     * Timestamp when the subscription was disabled. Null if subscription is active.
     * @type {Date}
     * @memberof Subscription
     */
    disabledAt?: Date;
    /**
     * 
     * @type {QueryExpression}
     * @memberof Subscription
     */
    query?: QueryExpression;
    /**
     * 
     * @type {SubscriptionCdc}
     * @memberof Subscription
     */
    cdc: SubscriptionCdc;
    /**
     * 
     * @type {SubscriptionQuotas}
     * @memberof Subscription
     */
    quotas?: SubscriptionQuotas;
    /**
     * Creation date of the resource.
     * @type {Date}
     * @memberof Subscription
     */
    createdAt: Date;
    /**
     * Last update date of the resource.
     * @type {Date}
     * @memberof Subscription
     */
    updatedAt: Date;
}



/**
 * Check if a given object implements the Subscription interface.
 */
export function instanceOfSubscription(value: object): value is Subscription {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('memberIdentifier' in value) || value['memberIdentifier'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('resourceType' in value) || value['resourceType'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('cdc' in value) || value['cdc'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function SubscriptionFromJSON(json: any): Subscription {
    return SubscriptionFromJSONTyped(json, false);
}

export function SubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Subscription {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'memberIdentifier': json['memberIdentifier'],
        'notificationType': SubscriptionNotificationTypeFromJSON(json['notificationType']),
        'resourceType': SubscriptionResourceTypeFromJSON(json['resourceType']),
        'resourceId': json['resourceId'] == null ? undefined : json['resourceId'],
        'status': SubscriptionStatusFromJSON(json['status']),
        'disabledAt': json['disabledAt'] == null ? undefined : (new Date(json['disabledAt'])),
        'query': json['query'] == null ? undefined : QueryExpressionFromJSON(json['query']),
        'cdc': SubscriptionCdcFromJSON(json['cdc']),
        'quotas': json['quotas'] == null ? undefined : SubscriptionQuotasFromJSON(json['quotas']),
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function SubscriptionToJSON(json: any): Subscription {
    return SubscriptionToJSONTyped(json, false);
}

export function SubscriptionToJSONTyped(value?: Subscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'memberIdentifier': value['memberIdentifier'],
        'notificationType': SubscriptionNotificationTypeToJSON(value['notificationType']),
        'resourceType': SubscriptionResourceTypeToJSON(value['resourceType']),
        'resourceId': value['resourceId'],
        'status': SubscriptionStatusToJSON(value['status']),
        'disabledAt': value['disabledAt'] == null ? value['disabledAt'] : value['disabledAt'].toISOString(),
        'query': QueryExpressionToJSON(value['query']),
        'cdc': SubscriptionCdcToJSON(value['cdc']),
        'quotas': SubscriptionQuotasToJSON(value['quotas']),
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

